import React from 'react';
import '../style/services.css';

import { LazyLoadImage } from 'react-lazy-load-image-component';
import Grid from '@mui/material/Grid';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import { Link } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { responsiveFontSizes, Typography } from '@mui/material';

import imgicon  from '../images/photo-service-2.jpg';
import imgicon2 from '../images/photo-service-1.jpg';
import imgicon3 from '../images/photo-service-3.jpg';
import imgicon4 from '../images/photo-service-5.jpg';
import imgicon5 from '../images/photo-service-4.jpg';
import imgicon6 from '../images/photo-service-6.jpg';
import imgicon7 from '../images/photo-service-7.jpg';
import imgicon8 from '../images/umzugsreinigung-photo.png';
import imgicon9 from '../images/High-pressure-cleaning.png';

/* Feather-style SVG paths — one per service */
const icons = {
  cleaning:    <svg
  viewBox="0 0 24 24"
  fill="none"
  stroke="#01b8b0"
  strokeWidth="2"
  strokeLinecap="round"
  strokeLinejoin="round"
  style={{ width: 18, height: 18, display: 'block', transition: 'stroke 0.3s' }}
>
  <path d="M9 6 L4 20 L20 20 L15 6 Z" />
  <line x1="6" y1="13" x2="18" y2="13" />
  <rect x="10" y="2" width="4" height="4" rx="1" />
  <line x1="12" y1="6" x2="12" y2="6.5" />
</svg>};

const ServiceIcon = ({ paths }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="#01b8b0"
    strokeWidth="2"
    style={{ width: 18, height: 18, display: 'block', transition: 'stroke 0.3s' }}
  >
    {paths}
  </svg>
);

function Servicescard() {
  const services = [
    {
      title: 'Büroreinigung',
      tag: 'Gewerbe',
      image: imgicon,
      icon: icons.cleaning,
      description:
        'Ein sauberes Büro steigert die Produktivität und das Wohlbefinden Ihrer Mitarbeiter. Wir kümmern uns um jede Ecke, damit Sie sich voll und ganz auf Ihr Geschäft konzentrieren können.',
      link: '/büroreinigung',
    },
    {
      title: 'Glas und Fensterreinigung',
      tag: 'Fassade',
      image: imgicon2,
      icon: icons.cleaning,
      description:
        'Klare Sicht und strahlende Fenster verleihen Ihrem Gebäude Glanz und machen einen positiven Eindruck auf Kunden und Besucher.',
      link: '/glasundfensterreinigung',
    },
    {
      title: 'Fassadenreinigung',
      tag: 'Außen',
      image: imgicon3,
      icon: icons.cleaning,
      description:
        'Fassadenreinigung mit umweltfreundlichen Pflegemitteln, die nicht nur für strahlende Sauberkeit sorgen, sondern auch die Umwelt schonen!',
      link: '/fassadenreinigung',
    },
    {
      title: 'Treppenhausreinigung',
      tag: 'Innen',
      image: imgicon4,
      icon: icons.cleaning,
      description:
        'Ein gepflegtes Treppenhaus ist die Visitenkarte eines jeden Gebäudes. Wir halten es sauber und einladend.',
      link: '/treppenhausreinigung',
    },
    {
      title: 'Praxisreinigung',
      tag: 'Medizin',
      image: imgicon5,
      icon: icons.cleaning,
      description:
        'Sauberkeit und Hygiene sind besonders in medizinischen Einrichtungen entscheidend. Wir sorgen für gründliche Reinigung, damit sich Ihre Patienten wohl und sicher fühlen.',
      link: '/praxisreinigung',
    },
    {
      title: 'Wohnungsreinigung',
      tag: 'Wohnen',
      image: imgicon6,
      icon: icons.cleaning,
      description:
        'Ihr Zuhause ist Ihre Oase. Wir kümmern uns darum, dass es makellos sauber ist, damit Sie sich entspannen und genießen können.',
      link: '/wohnungsreinigung',
    },
    {
      title: 'Bauabschlussreinigung',
      tag: 'Bau',
      image: imgicon7,
      icon: icons.cleaning,
      description:
        'Unsere spezialisierten Teams verwandeln Ihre Baustelle in einen makellosen, einladenden Raum, der bereit ist, übergeben oder genutzt zu werden.',
      link: '/bauabschlussreinigung',
    },
    {
      title: 'Umzugsreinigung',
      tag: 'Umzug',
      image: imgicon8,
      icon: icons.cleaning,
      description:
        'Beim Umzug gibt es genug zu tun. Überlassen Sie uns die Reinigung, damit Sie sich auf den reibungslosen Ablauf Ihres Umzugs konzentrieren können.',
      link: '/umzugsreinigung',
    },
    {
      title: 'Hochdruckreinigung',
      tag: 'Außen',
      image: imgicon9,
      icon: icons.cleaning,
      description:
        'Hartnäckiger Schmutz hat keine Chance gegen unsere Hochdruckreinigungstechniken. Wir bringen Oberflächen zum Strahlen, egal wie hartnäckig der Schmutz ist.',
      link: '/hochdruckreinigung',
    },
  ];

  let theme = createTheme();
  theme = responsiveFontSizes(theme);

  React.useEffect(() => {
    AOS.init({
      offset: 80,
      duration: 600,
      easing: 'ease-out-cubic',
      mirror: false,
      once: true,
    });
  }, []);

  return (
    <div className="services-content">
      <Grid
        container
        className="container-cards"
        spacing={2}
        sx={{ display: 'flex', justifyContent: 'center' }}
      >
        {services.map((service, index) => (
          <Grid
            key={index}
            item
            xs={12}
            sm={6}
            md={4}
            lg={4}
            sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
            data-aos="fade-up"
            data-aos-delay={index * 70}
          >
            <Link className="link-service" to={service.link}>
              <Paper
                className="services-card"
                elevation={0}
                sx={{
                  fontFamily: 'var(--fontFamily)',
                  height: 'auto',
                  width: { xs: 260, sm: 240, md: 220, lg: 250, xl: 260 },
                  marginTop: '12px',
                  marginBottom: '12px',
                }}
              >
                {/* Image with tag */}
                <div className="image-box">
                  <LazyLoadImage
                    src={service.image}
                    alt={service.title}
                    width="100%"
                    height="100%"
                    style={{ objectFit: 'cover', display: 'block' }}
                  />
                  <span className="service-tag">{service.tag}</span>
                </div>

                {/* Body */}
                <div className="card-body">
                  {/* Icon + title row */}
                  <div className="icon-row">
                    <div className="icon-box">
                      <ServiceIcon paths={service.icon} />
                    </div>
                    <ThemeProvider theme={theme}>
                      <Typography variant="h5" className="name-text">
                        {service.title}
                      </Typography>
                    </ThemeProvider>
                  </div>

                  {/* Description */}
                  <ThemeProvider theme={theme}>
                    <Typography variant="body2" className="description">
                      {service.description}
                    </Typography>
                  </ThemeProvider>

                  {/* CTA */}
                  <span className="cta-link">
                    Mehr erfahren <span className="cta-arrow">→</span>
                  </span>
                </div>
              </Paper>
            </Link>
          </Grid>
        ))}
      </Grid>
    </div>
  );
}

export default Servicescard;